import { render, staticRenderFns } from "./loading-component.vue?vue&type=template&id=7d3fc20c&lang=html"
import script from "./loading-component.vue?vue&type=script&lang=js"
export * from "./loading-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports